import { compareIso } from './dates.js'
import type { IsoDate } from './dates.js'
import { applyRate } from './money.js'
import type { Minor } from './money.js'
import type { FxRate } from './types.js'

export interface Conversion {
  amountPlnMinor: Minor
  rate: number
  rateDate: IsoDate
}

/**
 * Znajduje kurs obowiązujący na dany dzień: notowanie z tego dnia albo
 * ostatnie wcześniejsze (weekendy i święta nie mają notowań NBP).
 */
export function findRate(rates: readonly FxRate[], currency: string, on: IsoDate): FxRate | null {
  let best: FxRate | null = null
  for (const rate of rates) {
    if (rate.currency !== currency) continue
    if (compareIso(rate.date, on) > 0) continue
    if (best === null || compareIso(rate.date, best.date) > 0) best = rate
  }
  return best
}

export function convertToPln(
  amount: Minor,
  currency: string,
  on: IsoDate,
  rates: readonly FxRate[],
): Conversion | null {
  if (currency === 'PLN') {
    return { amountPlnMinor: amount, rate: 1, rateDate: on }
  }
  const found = findRate(rates, currency, on)
  if (found === null) return null
  return {
    amountPlnMinor: applyRate(amount, found.rate),
    rate: found.rate,
    rateDate: found.date,
  }
}
